export default function Logo() {
  return (
    <h1>
      <span>🥩</span>Shopping List<span>🛒</span>
    </h1>
  );
}
